var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: "#808080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,500c0-182.8,100.4-342.3,249.1-426.3C330.3,33.5,412.5,10.6,500,10.6c270.6,0,490,219.1,490,489.4c0,270.3-219.3,489.4-490,489.4C229.4,989.4,10,770.3,10,500L10,500z M500,71.8C263.2,71.8,71.2,263.5,71.2,500c0,236.5,192,428.2,428.8,428.2c236.8,0,428.7-191.7,428.7-428.2C928.7,263.5,736.8,71.8,500,71.8L500,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,222.3c19.3-15.9,38.6-33.5,57.9-49.3c61.4,79.3,115.7,169.1,115.7,273.1c14,125.1-38.6,248.4-126.2,334.7c-15.8-17.6-33.3-33.5-49.1-51.1c56.1-72.2,103.4-156.8,103.4-250.2C638.9,382.6,591.6,294.5,532,222.3L532,222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.8,343.8l50.8-51.1c45.6,52.8,84.1,114.5,77.1,186.7c5.3,72.2-38.6,130.4-80.6,183.2c-15.8-19.4-33.3-40.5-49.1-59.9c24.5-37,57.9-75.8,56.1-123.3C472.3,428.4,437.3,386.1,412.8,343.8L412.8,343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,476c28-28.2,56.1-54.6,85.9-81c12.3,26.4,26.3,54.6,33.3,82.8c-5.3,28.2-26.3,51.1-42.1,74C330.4,527.1,304.1,502.4,279.5,476L279.5,476z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.ba66c345be2913bbc87b4aebcb8d1a5a.svg";
export { ForwardRef as ReactComponent };